import { Provider } from "react-redux";
import "./App.css";
import { store } from "./redux/store";
import OldApp from "./oldApp/App";
import { BrowserRouter } from "react-router-dom";
import Maintenance from "./components/maintenance";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        {/* <Maintenance /> */}
        <OldApp />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
